import PermissionChecker from '@/security/permission-checker';
import Permissions from '@/security/permissions';

export class FormsPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.formsRead,
        );
        this.create = permissionChecker.match(
            Permissions.values.formsCreate,
        );
        this.edit = permissionChecker.match(
            Permissions.values.formsEdit,
        );
        this.destroy = permissionChecker.match(
            Permissions.values.formsDestroy,
        );
    }
}
